<section class="account">
  <c2h-side-menu-account></c2h-side-menu-account>
  <div class="account-content">
    <router-outlet></router-outlet>
  </div>
</section>
